export const TEAMF_824_FLAG_NAME = 'teamf-824-global-filter-side-nav';

export const TEAMF_824_TREATMENT = 'treatment';
